export default __webpack_public_path__ + "static/media/DNo.32-4.e3d772b4.jpg";